// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"445":"1bfc9850","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"445":"e5660ead2666ef0119e6","532":"f719ee328b98c057cbce","678":"eeab0cdeb474ba44557b","883":"85740a607d8880f41ac9"}[chunkId] + ".js";
};